import { useEffect } from 'react'
import { logNotice, logWarning } from 'shared-code/log'
import { PlaywireContext } from 'shared-components/contexts/PlaywireContext'
import { PostContext } from 'shared-components/contexts/PostContext'

export const defaultTaggless: PlaywireTagglessType[] = [
  'bottom_rail',
  'corner_ad_video',
  'site_skin',
]

export function useTaglessAd(input = defaultTaggless): void {
  const { inst } = PlaywireContext.useContainer()
  const { disabledAds } = PostContext.useContainer()

  useEffect(() => {
    if (!inst) {
      return
    }

    const inputNorm: PlaywireTagglessType[] = disabledAds ? [] : [...input, 'in_content', 'flex']
    const units = inputNorm.map(type => ({ type }))

    const { addUnits, displayUnits } = inst
    void (async () => {
      await clearTaglessUnits(inst, getTagglessKeys(inst, inputNorm))

      if (units.length === 0) {
        return
      }
      try {
        logNotice('Adding units', units)
        await addUnits(units)
        await displayUnits()
      } catch (e) {
        logWarning('Playwire error', e)
      }
    })()

    return () => {
      void clearTaglessUnits(inst, getTagglessKeys(inst, inputNorm))
    }
  }, [inst, input, disabledAds])
}

async function clearTaglessUnits(runtime: PlaywireRuntimeProps, units: string[]): Promise<void> {
  if (runtime) {
    logNotice('PlaywireTaggedless units cleanup', {
      runtime,
      units,
    })

    if (units.length) {
      // playwire cleanup
      logNotice('Destroying taggless units', units)
      await runtime.destroyUnits(units)
    }
  }
}

function getTagglessKeys(runtime: PlaywireRuntimeProps, input: PlaywireTagglessType[]): string[] {
  return Object.keys(runtime.settings.slots).filter(key =>
    input.includes(runtime.settings.slots[key].type as PlaywireTagglessType)
  )
}
